module.exports = __webpack_public_path__ + "static/media/straightTruck.d67a871f.svg";